<template>
  <div style="margin-right: 0.5rem; display: flex;" :style="{width: width + 'px', minWidth: width + 'px', height: width + 'px', maxHeight: width + 'px'}">
    <img :class="variant" v-if="!actorLogoHasError && !showFallbackLogo" :src="actorLogo(actor)" @error="actorLogoHasError = true;"/>
    <img :class="variant" v-else-if="actorLogoHasError && !showFallbackLogo" :src="getClearbitActorLogo(actorLogoUrl || actor.url)" @error="actorClearbitLogoHasError = true;"/>
    <img :class="variant" v-else-if="actorClearbitLogoHasError || showFallbackLogo" src="/images/datascouts-logo.svg"/>
  </div>
</template>
<script lang="ts">
  import { defineComponent } from 'vue'
  import { actorLogo, getLogoDevLogoUrl } from '@/util/actor'

  export default defineComponent({
    name: "ActorAvatar",
    props: {
      actor: {
        type: Object,
        required: true,
      },
      actorLogoUrl: {
        type: String,
        required: false,
      },
      variant: {},
      width: {
        type: Number,
        default: 100,
      }
    },
    data() {
      return {
        actorLogoHasError: false,
        actorClearbitLogoHasError: false,
        showFallbackLogo: false,
      }
    },
    methods: {
      actorLogo,
      getClearbitActorLogo: getLogoDevLogoUrl,
    },
    mounted() {
      if (actorLogo(this.actor) === undefined && this.actor.url === '') {
        this.showFallbackLogo = true
      }
    }
  })
</script>
<style scoped lang="scss">

  img {
    min-width: 100%;
  }

  .rounded {
    border-radius: 0.5rem;
  }

</style>
